import { ColumnConfig } from '@/components/table/Table';
import {
  renderShippingId,
  renderStatus,
  renderTags,
  renderDtStart,
  renderName,
  renderTicketBadge,
  renderFoundButton,
} from '../renderers';

export const inboxTableColumns: ColumnConfig[] = [
  {
    label: '#',
    field: 'trackNumber',
    render: renderTicketBadge,
  },
  {
    label: 'Estado',
    field: 'status',
    render: renderStatus,
  },
  {
    label: 'Pedido / Externo',
    field: 'shippingId',
    render: renderShippingId,
  },

  {
    label: 'Nombre / Celular',
    field: 'name',
    render: renderName,
  },
  {
    label: 'Documento',
    field: 'documentNumber',
  },

  {
    label: 'Razón',
    field: 'reason',
  },
  {
    label: 'Ubicación',
    field: 'shippingLocation',
  },
  {
    label: 'Pickeado?',
    field: 'found',
    render: renderFoundButton,
  },
  {
    label: 'Tags',
    field: 'tags',
    render: renderTags,
  },
  {
    label: 'Inicio de atención',
    field: 'dtStart',
    render: renderDtStart,
  },
];
